<template>
    <v-dialog v-model="open" max-width="420" persistent>
        <v-card>
            <v-card-title class="d-flex justify-space-between align-center">
                {{ titleProp }}
                <v-btn icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pb-0">
                <div class="body-2 grey--text text--darken-1 mb-3 text-left">Select the sections to include in the PDF.</div>
                <v-checkbox
                    v-model="config.includeVehicleInspection"
                    label="Vehicle Inspection"
                    dense
                    hide-details
                />
                <v-checkbox
                    v-model="config.includeQualityCheck"
                    label="Quality Checks"
                    dense
                    hide-details
                />
                <v-checkbox
                    v-model="config.includeTyreChecks"
                    label="Tyre Checks"
                    dense
                    hide-details
                />
                <v-checkbox
                    v-model="config.includeBatteryDetails"
                    label="Battery Details"
                    dense
                    hide-details
                />
                <v-checkbox
                    v-model="config.includeInvoice"
                    label="Costing"
                    dense
                    hide-details
                    class="mb-2"
                />
                <v-checkbox
                    v-model="config.includeAttachments"
                    label="Attachments"
                    dense
                    hide-details
                    class="mb-2"
                />
            </v-card-text>

            <v-card-actions class="pa-4 pt-2">
                <v-spacer />
                <v-btn text @click="$emit('close')">Cancel</v-btn>
                <v-btn color="primary" :loading="loading" @click="generate">
                    <v-icon left>mdi-printer</v-icon>Generate
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {pdfService, quoteRequestService} from '@/services';
import {downloadHelper, quoteRequestJobcardType} from '@/helpers';

export default {
    name: 'print-quote-request-jobcard-dialog',
    props: {
        titleProp: {
            type: String,
            default: '',
        },
        uniqueIdProp: {
            type: String,
            required: true,
        },
        jobcardTypeProp: {
            type: Number,
            default: null,
        }
    },
    data: () => ({
        open: true,
        loading: false,
        config: {
            DocumentColorScheme: '#F47B3E', // Cartrack color
            includeDetails: true,
            includeQualityCheck: true,
            includeVehicleInspection: true,
            includeTyreChecks: false,
            includeBatteryDetails: false,
            includeInvoice: true,
            includeSignatures: true,
            includeAttachments: true,
        },
    }),
    created() {
        if (this.jobcardTypeProp === quoteRequestJobcardType.TYPE) {
            this.config.includeTyreChecks = true;
        }
        
        if (this.jobcardTypeProp === quoteRequestJobcardType.BATTERY) {
            this.config.includeBatteryDetails = true;
        }
    },
    methods: {
        async generate() {
            this.loading = true;
            try {
                const fileName = `jobcard-${this.uniqueIdProp}`;
                
                const result = await pdfService.generateQuoteRequestJobcardByUniqueId(this.uniqueIdProp, this.config);
                
                if (result.status === 200) {
                    downloadHelper.downloadContent(result.data, fileName, 'application/pdf');
                }
                else {
                    console.error('Error downloading PDF:', result.statusText);
                }

                this.$emit('close');
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
